import type { Entity, ValidatorType } from "shelving";
import { DATA, INTEGER, KEY } from "shelving";
import { CONTENT_ENTITY } from "./entity.js";

export const REACTION_MAX = 48;
export const REACTOR_MAX = 48;

/**
 * List of reaction counts on an entity.
 */
export const REACTION_SCHEMA = DATA({
	reaction: KEY,
	target: CONTENT_ENTITY,
	count: INTEGER,
});

/** Get the item for a user's reaction on a specific target. */
export const getReactionID = (target: Entity, reaction: string): string => `${target}:${reaction}`;

/**
 * List of reactions on an entity.
 * - Reactors are keyed by the target type and ID of the content they apply to _and_ the UID of the user who reacted.
 */
export const REACTOR_SCHEMA = DATA({
	uid: KEY,
	target: CONTENT_ENTITY,
	reaction: KEY,
	date: INTEGER,
});
export type ReactorData = ValidatorType<typeof REACTOR_SCHEMA>;

/** Get the item for a user's reaction on a specific target. */
export const getReactorID = (target: Entity, uid: string): string => `${uid}:${target}`;
